import { AppBar } from "@material-ui/core";

export type { AppBarProps } from "@material-ui/core";

export default AppBar;
